const variants = {
	hidden: {
		y: "-100vh",
		x: "-50%",
	},
	visible: {
		y: 0,
		x: "-50%",
		transition: {
			ease: "easeOut",
			duration: 0.7,
		},
	},
	exit: {
		y: "-100vh",

		transition: {
			ease: "easeIn",
			duration: 0.7,
		},
	},
};

export default variants;
